export const authRoles = {
    sa: ["SA",'ADMIN', "SUPPORT_ADMIN"],
    support_admin: ['SUPPORT_ADMIN'], 
    admin: ['ADMIN', "SUPPORT_ADMIN"]
}